import {combineReducers} from 'redux'
import {connectRouter} from 'connected-react-router'
import {isFeatureEnabled, FlagPages} from 'config/featureFlags'

// Feature-controlled reducers
import users from './users'
import account from './account'
import notifier from './notifier'
import charts from './charts'
import chartsLiveData from './chartsLiveData'
import stations from './stations'
import unbalance from './unbalance'
import generalUnbalance from './generalUnbalance'
import unbalanceDeviations from './unbalanceDeviations'
import reportFiles from './reportFiles'
import businessPlan from './businessPlan'
import businessPlanDetails from './businessPlanDetails'
import generalStatistic from './generalStatistic'
import forecast from './forecast'
import restrictionsJournal from './restrictionsJournal'
import sidebar from './sidebar'
import map from './map'
import operationalJournal from './operationalJournal'
import shift from './shift'
import shiftTransferHistory from './shiftTransferHistory'
import administration from './administration'

const rootReducer = history =>
  combineReducers({
    router: connectRouter(history),

    // Feature-controlled reducers
    ...(isFeatureEnabled(FlagPages.USERS_PAGE) && {users}),

    account,
    notifier,
    charts,
    chartsLiveData,
    stations,

    // Unbalance reducers - controlled by feature flag
    ...(isFeatureEnabled(FlagPages.UNBALANCE_PAGE) && {
      unbalance,
      generalUnbalance,
      unbalanceDeviations,
    }),

    reportFiles,
    businessPlan,
    businessPlanDetails,
    generalStatistic,
    forecast,
    restrictionsJournal,
    sidebar,

    // Map reducer - controlled by feature flag
    ...(isFeatureEnabled(FlagPages.MAP_PAGE) && {map}),

    operationalJournal,
    shift,
    shiftTransferHistory,

    // Administration reducer - controlled by feature flag
    ...(isFeatureEnabled(FlagPages.ADMINISTRATION_PAGE) && {administration}),
  })

export default rootReducer
